import { css } from '@emotion/css'

export const container = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: justify;
  box-sizing: border-box;
  padding: 1.5em;
`

export const logo = css`
  height: 180px;
  width: auto;
`
